"use client";

import { c as _c } from "react/compiler-runtime";
import type { NftOwner } from "@/entities/IOwner";
import { useNftContractBalances } from "@/hooks/useNftBalance";
import { createContext, useContext, useMemo, type ReactNode } from "react";
interface NftBalancesContextValue {
  readonly consolidationKey: string | null;
  readonly contract: string;
  readonly balancesByTokenId: Map<number, number>;
  readonly isLoading: boolean;
  readonly error: Error | null;
}
const NftBalancesContext = createContext<NftBalancesContextValue | null>(null);
const normalizeContract = (contract: string): string => contract.toLowerCase();
const buildBalancesByTokenId = (balances: NftOwner[]): Map<number, number> => {
  const balancesByTokenId = new Map<number, number>();
  for (const balance of balances) {
    balancesByTokenId.set(balance.token_id, (balancesByTokenId.get(balance.token_id) ?? 0) + balance.balance);
  }
  return balancesByTokenId;
};
export function NftBalancesProvider(t0) {
  const $ = _c(20);
  const {
    children,
    consolidationKey,
    contract,
    tokenIds,
    enabled: t1
  } = t0;
  const enabled = t1 === undefined ? true : t1;
  let t2;
  if ($[0] !== consolidationKey || $[1] !== contract || $[2] !== enabled || $[3] !== tokenIds) {
    t2 = {
      consolidationKey,
      contract,
      tokenIds,
      enabled
    };
    $[0] = consolidationKey;
    $[1] = contract;
    $[2] = enabled;
    $[3] = tokenIds;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const {
    data,
    isLoading,
    error
  } = useNftContractBalances(t2);
  let t3;
  if ($[5] !== contract) {
    t3 = normalizeContract(contract);
    $[5] = contract;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== data) {
    t4 = data ?? [];
    $[7] = data;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t4) {
    t5 = buildBalancesByTokenId(t4);
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const t6 = error instanceof Error ? error : null;
  let t7;
  if ($[11] !== consolidationKey || $[12] !== isLoading || $[13] !== t3 || $[14] !== t5 || $[15] !== t6) {
    t7 = {
      consolidationKey,
      contract: t3,
      balancesByTokenId: t5,
      isLoading,
      error: t6
    };
    $[11] = consolidationKey;
    $[12] = isLoading;
    $[13] = t3;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  const value = t7;
  let t8;
  if ($[17] !== children || $[18] !== value) {
    t8 = <NftBalancesContext.Provider value={value}>{children}</NftBalancesContext.Provider>;
    $[17] = children;
    $[18] = value;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  return t8;
}
export function useNftBalanceFromContext(t0) {
  const $ = _c(7);
  const {
    consolidationKey,
    contract,
    tokenId
  } = t0;
  const context = useContext(NftBalancesContext);
  if (!context || !consolidationKey || context.consolidationKey !== consolidationKey || context.contract !== normalizeContract(contract)) {
    return null;
  }
  let t1;
  if ($[0] !== context.balancesByTokenId || $[1] !== tokenId) {
    t1 = context.balancesByTokenId.get(tokenId) ?? 0;
    $[0] = context.balancesByTokenId;
    $[1] = tokenId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== context.error || $[4] !== context.isLoading || $[5] !== t1) {
    t2 = {
      balance: t1,
      isLoading: context.isLoading,
      error: context.error
    };
    $[3] = context.error;
    $[4] = context.isLoading;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}